import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { policyListRequest } from '../../../redux/policy/policy.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const PolicyList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { policyListSuccess, policyListError } = useSelector(state => state.policy)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [emptyFieldCounter, setEmptyFieldCounter] = useState(0)
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedTab, setSelectedTab] = useState(0)

    const TAB_ITEMS = {
        ALL: 'ALL',
        ASSIGNED_POLICIES: 'ASSIGNED POLICIES'
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.POLICY_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user)) {
            fetchPolicyList(selectedTab)
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.POLICY_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.POLICY_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(policyListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(policyListError)) {
            setLoading(false)
        }
    }, [policyListSuccess, policyListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchPolicyList(selectedTab)
        }
    }, [selectedLocation])

    const fetchPolicyList = (tabIndex) => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            if (!isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            if (tabIndex === 1) {
                data.id = user.data.userDetails.employeeId
                data.userType = user.data.userDetails.userType
            }
        }

        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(policyListRequest(data))
    }

    const handleAddPolicyClick = () => {
        navigate(ROUTES.policies.add)
    }

    const handleSearchClick = () => {
        if (isEmpty(searchQuery)) {
            if (Number(emptyFieldCounter) < 3) {
                let currentCounter = emptyFieldCounter
                setEmptyFieldCounter(currentCounter + 1)
                // const data = {}
                // fetchOfferList(data)
                fetchPolicyList(selectedTab)
            } else {
                displayErrorToast('Please try refreshing the page.')
            }
        } else {
            // const data = {}
            // fetchOfferList(data)
            fetchPolicyList(selectedTab)
        }
    }

    const handleViewDetail = item => {
        navigate(ROUTES.policies.details, {
            state: {
                policyId: item.policyId,
                isAssignedPolicies: selectedTab === 1 ? true : false,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
        })
    }

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.ALL) {
            setSelectedTab((prevTab) => {
                const newTab = 0
                fetchPolicyList(0)
                return newTab
            })
        } else {
            setSelectedTab((prevTab) => {
                const newTab = 1
                fetchPolicyList(1)
                return newTab
            })
        }
    }

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.POLICIES, PERMISSION_SUB_TYPE.POLICIES.ADD_POLICY, employeeSelectedBusiness, employeeSelectedLocation)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Policies' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="ol-search-parent-container">
                    <div className="ol-search-row-parent-container">
                        <div className="ol-search-input-container">
                            <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Policy" />
                        </div>
                        <div className="ol-search-icon-container" onClick={() => { handleSearchClick() }}>
                            <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                        </div>
                    </div>
                </div>
                {isLoggedInUserEmployee(user) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ALL) }}>{TAB_ITEMS.ALL}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ASSIGNED_POLICIES) }}>{TAB_ITEMS.ASSIGNED_POLICIES}</div>
                </div>}
                {!isNull(policyListSuccess) && !isEmpty(policyListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Created On</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {policyListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{moment.utc(element.createdOn).local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(policyListError) && <div className="content-error">{policyListError.message}</div>}
                {isPermissionAllowed() && <div className="vl-fab-container" onClick={() => handleAddPolicyClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PolicyList